import axios from 'axios'
import {
  GetNotificationRequest,
  GetNotificationResponse,
} from './Notification.types'
import { APIResponse } from '../acccount/Account.types'

const API_URL = process.env.REACT_APP_API_URL

export const NOTIFICATION_ENDPOINT = `${API_URL}/notification`

export function getNotifications(params?: GetNotificationRequest) {
  return axios.get<GetNotificationResponse>(NOTIFICATION_ENDPOINT, { params })
}

export function readAllNotifications() {
  return axios.post<APIResponse>(`${NOTIFICATION_ENDPOINT}/read-all`)
}

export function readNotification(id: string) {
  return axios.put<APIResponse>(`${NOTIFICATION_ENDPOINT}/${id}/read`)
}
